import { useCallback } from 'react'
import { FiCheck, FiLock } from 'react-icons/fi'

import { joinClassNames } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import styles from '../styles.module.css'

export const DrawerContent = ({
  className,
  columns,
  visibleColumnsLabel,
  handleToggleColumn,
  onResetToDefault
}: DrawerContentProps) => {
  const { t } = useAPPTranslation()

  const iconClassName = useCallback(
    (isReadonly: boolean) =>
      joinClassNames(styles.rowIcon, isReadonly && styles.rowIconReadonly),
    []
  )

  const spanClass = useCallback(
    (column: ColumnSelectorColumn) =>
      !column.isReadonly && !column.isSelected ? styles.rowIconHidden : '',
    []
  )

  return (
    <div className={joinClassNames(styles.drawer, className)}>
      <div className={styles.summary}>
        <span className={styles.visibleCount}>{visibleColumnsLabel}</span>

        {onResetToDefault && (
          <button
            className={styles.uncheckAll}
            onClick={onResetToDefault}
            type="button"
          >
            {t('c:components.ColumnSelector.Drawer.resetToDefault')}
          </button>
        )}
      </div>

      <ul className={styles.list}>
        {columns.map(column => (
          <li className={styles.listItem} key={column.label}>
            <label
              className={styles.row}
              data-readonly={column.isReadonly}
              data-selected={column.isSelected}
            >
              <input
                type="checkbox"
                checked={column.isSelected}
                disabled={column.isReadonly}
                onChange={() => handleToggleColumn(column.label)}
                aria-label={column.name}
                className={styles.checkbox}
              />
              <span className={styles.rowLabel}>{column.name}</span>

              <span
                aria-hidden="true"
                className={joinClassNames(
                  iconClassName(column.isReadonly),
                  spanClass(column)
                )}
              >
                {column.isReadonly ? <FiLock /> : <FiCheck />}
              </span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  )
}
